import { useMutation } from '@tanstack/react-query';
import { authApi } from '@/lib/api-client';

interface SetupResponse {
  data: {
    qrCodeUrl: string;
    secret: string;
    uri: string;
  };
}

interface VerifySetupResponse {
  data: {
    backupCodes: string[];
  };
}

interface Verify2FAResponse {
  data: {
    user: {
      id: string;
      email: string;
      name: string;
      role: 'super_admin' | 'owner' | 'admin' | 'manager' | 'employee';
      tenantId: string | null;
    };
  };
}

interface BackupCodesResponse {
  data: {
    backupCodes: string[];
  };
}

export function useSetup2FA() {
  return useMutation({
    mutationFn: () => authApi.post<SetupResponse>('/auth/2fa/setup'),
  });
}

export function useVerifySetup2FA() {
  return useMutation({
    mutationFn: (data: { code: string }) => authApi.post<VerifySetupResponse>('/auth/2fa/verify-setup', data),
  });
}

export function useVerify2FA() {
  return useMutation({
    mutationFn: (data: { pendingToken: string; code: string }) =>
      authApi.post<Verify2FAResponse>('/auth/2fa/verify', data),
  });
}

export function useDisable2FA() {
  return useMutation({
    mutationFn: (data: { code: string }) => authApi.post<{ data: { message: string } }>('/auth/2fa/disable', data),
  });
}

export function useRegenerateBackupCodes() {
  return useMutation({
    mutationFn: (data: { code: string }) => authApi.post<BackupCodesResponse>('/auth/2fa/backup-codes', data),
  });
}
